import { Link } from 'react-router-dom'
import { useOnboardingProgress } from '../hooks/useOnboardingProgress'
import { cn } from '../lib/utils'

export const OnboardingChecklist = () => {
  const { steps, completedSteps, isDismissed, progress, isComplete, dismiss, isLoading } = useOnboardingProgress()

  if (isLoading || isDismissed) return null

  return (
    <div className="bg-surface border border-border rounded-2xl overflow-hidden mb-4">
      {/* Header */}
      <div className="px-5 pt-5 pb-4 flex items-start justify-between gap-3">
        <div className="flex-1">
          <h2 className="font-semibold text-text-primary text-base mb-0.5">
            {isComplete ? 'You\'re all set!' : 'Get started with DoorChart'}
          </h2>
          <p className="text-sm text-text-muted">
            {isComplete
              ? 'Your household is fully set up.'
              : `${completedSteps.length} of ${steps.length} steps complete`}
          </p>
        </div>
        <button
          onClick={() => dismiss.mutate()}
          className="text-text-muted hover:text-text-secondary shrink-0"
          aria-label="Dismiss"
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      {/* Progress bar */}
      <div className="px-5 pb-4">
        <div className="h-1.5 bg-border rounded-full overflow-hidden">
          <div
            className="h-full bg-primary rounded-full transition-all duration-500"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>

      {/* Steps */}
      <div className="divide-y divide-border/60">
        {steps.map((step) => {
          const done = completedSteps.includes(step.id)
          return (
            <div key={step.id} className="flex items-center gap-3 px-5 py-3.5">
              {/* Checkmark */}
              <div className={cn(
                'w-5 h-5 rounded-full flex items-center justify-center border shrink-0 transition-colors',
                done ? 'bg-primary border-primary' : 'border-border'
              )}>
                {done && (
                  <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                  </svg>
                )}
              </div>

              <span className={cn(
                'flex-1 text-sm',
                done ? 'text-text-muted line-through' : 'text-text-primary'
              )}>
                {step.label}
              </span>

              {!done && (
                <Link
                  to={step.path}
                  className="text-xs font-semibold text-primary hover:text-primary/80"
                >
                  Do it →
                </Link>
              )}
            </div>
          )
        })}
      </div>

      {isComplete && (
        <div className="px-5 pb-5 pt-2">
          <button
            onClick={() => dismiss.mutate()}
            className="w-full bg-primary/10 text-primary rounded-xl py-2.5 text-sm font-semibold"
          >
            Got it, dismiss
          </button>
        </div>
      )}
    </div>
  )
}
